<script>
import TheMixin from "../../mixin/TheHeader";
import { jtailsMainMenuShopList, jtailsMainMenuRightShopList } from "@src/config/menu";
import { getStoreOption } from "@utils/ipetbooking-options";

export default {
  components: {
    Logo: () => import("@layout/wordpress/TheLogo"),
  },
  mixins: [TheMixin],
  data() {
    return {
      isSearchOpen: false,
      query: '',
      shopUrl: window.globalData.APP_SHOP_URL,
      visibleList: [],
    }
  },
  computed: {
    menuList() {
      return jtailsMainMenuShopList();
    },
    menuRightList() {
      return jtailsMainMenuRightShopList();
    },
  },
  created() {
    this.visibleList = this.menuList.map(() => false)
  },
  methods: {
    goToLogin() {
      if(liff.isInClient() && this.isLiffInit) {
        lineGetProfileAndLogin({
          liffId: this.currentLiffId,
          callBack: () => {
            messageSuccess({
              title: '驗證成功',
              content: '您已成功登入。',
            });
          },
        })
      } else {
        this.$globalDialog('DialogLogin', {
          afterLoginRouteName: 'shop/member',
        })
      }
    },
    goToMember() {
      this.$router.push({
        name: 'shop-member'
      })
    },
    showSearch(e) {
      if(['I', 'SPAN'].includes(e.target.tagName)) {
        if(this.isSearchOpen === true) {
          if(this.query !== '') this.searchProduct()
          else this.closeSearch()
        } else {
          this.isSearchOpen = true;
          this.$nextTick(() => {
            if(this.$globalHambugerOpen)
              setTimeout(() => {
                this.$refs['searchMobileInput'].focus();
              }, 1000);

            this.$refs['searchInput'][0].focus();
          })
        }
      }
    },
    closeSearch() {
      this.isSearchOpen = false;
    },
    searchProduct() {
      if(this.query !== '')
        window.location = `${window.globalData.APP_SHOP_URL}?s=${this.query}&post_type=product`;
    },
    onClickToggleVisible(index) {
      this.visibleList[index] = !this.visibleList[index]
      this.visibleList = [...this.visibleList]
    },
  }
}
</script>
<!-- section template -->
<template>
  <header :class="$style.header">
    <div class="header__inner">
      <div class="container--shop">
        <div class="header__headerList row">
          <div class="header__headerLeft col-3"></div>
          <div class="header__headerCenter col-6 text-center">
            <Logo/>
          </div>
          <div class="header__headerRight col-3">
            <ul :class="$style.menuRightList">
              <template v-for="(menuRightItem, index) in menuRightList">
                <li
                  :key="`menuRightList-${index}`"
                  class="menuRightList__item"
                  :class="menuRightItem.type || 'link'"
                >
                  <template v-if="menuRightItem.type === 'link' || !menuRightItem.type">
                    <router-link
                      class="menuRightList__link"
                      :class="{ isLoggedIn: isLoggedIn && menuRightItem.to.name === 'shop-member' }"
                      :to="menuRightItem.to"
                      active-class="isActive"
                      @click.native="$globalHambugerOpen = false"
                    >
                      <i v-if="menuRightItem.icon" :class="`menuRightList__icon ${menuRightItem.icon}`"></i>
                      <span>{{ menuRightItem.title }}</span>
                    </router-link>
                  </template>
                  <template v-if="menuRightItem.type === 'a'">
                    <a
                      class="menuRightList__link"
                      :href="menuRightItem.href"
                      :target="menuRightItem.target"
                    >
                      <i v-if="menuRightItem.icon" :class="`menuRightList__icon ${menuRightItem.icon}`"></i>
                      <span>{{ menuRightItem.title }}</span>
                    </a>
                  </template>
                  <template v-if="menuRightItem.type === 'login'">
                    <div
                      class="menuRightList__link"
                      @click="goToLogin"
                    >
                      <i v-if="menuRightItem.icon" :class="`menuRightList__icon ${menuRightItem.icon}`"></i>
                      <span>{{ menuRightItem.title }}</span>
                    </div>
                  </template>
                  <template v-if="menuRightItem.type === 'search'">
                    <span
                      class="menuRightList__link menuRightList__search"
                      @click="showSearch"
                    >
                      <div :class="$style.headerSearch">
                        <transition name="fade">
                          <div v-if="isSearchOpen" class="headerSearch__box">
                            <div class="container">
                              <div class="headerSearch__inputBox">
                                <input
                                  ref="searchInput"
                                  v-model="query"
                                  class="headerSearch__input"
                                  type="text"
                                  placeholder="找商品"
                                  inputmode="search"
                                  @keyup.enter="searchProduct"
                                />
                                <div class="headerSearch__close" @click.stop="closeSearch"></div>
                              </div>
                            </div>
                          </div>
                        </transition>
                      </div>
                      <i v-if="menuRightItem.icon"
                         :class="`menuRightList__icon ${menuRightItem.icon} hidden xl:flex`"></i>
                      <!-- <i class="fontello fontello-search hidden xl:flex"></i> -->
                    </span>
                  </template>
                  <template v-if="menuRightItem.type === 'cart'">
                    <a
                      class="menuRightList__link isMiniCart"
                      :href="menuRightItem.href"
                      :target="menuRightItem.target"
                    >
                      <i v-if="menuRightItem.icon" :class="`menuRightList__icon ${menuRightItem.icon}`"></i>
                      <!-- <span class="badge">4</span> -->
                    </a>
                    <div class="menuRightList__miniCart">
                      
                    </div>
                  </template>
                </li>
              </template>
            </ul>
          </div>
          <div class="header__bottom col-12">
            <ul :class="$style.menuList">
              <template v-for="(menuItem, index) in menuList">
                <li
                  :key="index"
                  class="menuList__item link"
                >
                  <a
                    class="menuList__link"
                    :href="menuItem.url"
                  >
                    <!-- <i v-if="menuItem.icon" :class="`menuList__icon ${menuItem.icon} mr-2`"></i> -->
                    <span>{{ menuItem.title }}</span>
                  </a>
                </li>
              </template>
            </ul>
          </div>
        </div>
        <div class="header__headerList--mobile">
          <div class="header__headerLeft">
            <div class="header__icon hambuger" @click="$globalHambugerOpen = !$globalHambugerOpen">
              <div v-if="$globalHambugerOpen" class="hambuger__close"></div>
              <i v-else class="fal fa-bars"></i>
            </div>
            <span
              class="header__icon flex ml-2"
              style="margin-top: -3px;padding-left: 6px;"
              @click="showSearch"
            >
              <i class="fontello fontello-search fa-xl"></i>
              <div :class="$style.headerSearch">
                <transition name="fade">
                  <div v-show="isSearchOpen" class="headerSearch__box">
                    <div class="container">
                      <div class="headerSearch__inputBox">
                        <input
                          ref="searchMobileInput"
                          v-model="query"
                          class="headerSearch__input"
                          type="text"
                          placeholder="找商品"
                          inputmode="search"
                          @keyup.enter="searchProduct"
                        />
                        <div class="headerSearch__close" @click.stop="closeSearch"></div>
                      </div>
                    </div>
                  </div>
                </transition>
              </div>
            </span>
          </div>
          <div class="header__headerCenter">
            <Logo/>
          </div>
          <div class="header__headerRight">
            <div
              class="header__icon"
              @click="isLoggedIn ? goToMember() : goToLogin()"
            >
              <i class="fontello fontello-user"></i>
            </div>
            <a
              class="header__icon"
              :href="shopUrl"
              target="_blank"
            >
              <span></span>
              <i class="fontello fontello-shopping-bag"></i>
            </a>
          </div>
          <div :class="[$style.mobileMenu, { [$style.isMenuOpen]: $globalHambugerOpen }]">
            <div class="mobileMenu__top">
              <div
                :class="$style.mobileMenuList"
              >
                <template v-for="(menuItem, index) in menuList">
                  <div
                    :key="index"
                    class="mobileMenuList__item"
                    :class="menuItem.type || 'link'"
                  >
                    <a
                      class="mobileMenuList__link"
                      :class="{ isActive: visibleList[index] }"
                      :href="menuItem.url"
                    >
                      <!-- <i v-if="menuItem.icon" :class="`mobileMenuList__icon ${menuItem.icon}`"></i> -->
                      <span>{{ menuItem.title }}</span>
                      <template v-if="menuItem.children">
                        <i class="fal fa-chevron-down dropdown-button px-2" @click.stop.prevent="onClickToggleVisible(index)"></i>
                        <div class="mobileMenuList__sublist">
                          <div v-for="(children, childrenIndex) in menuItem.children" :key="childrenIndex" class="mobileMenuList__item">
                            <a class="mobileMenuList__link" :href="children.url">{{ children.title }}</a>
                          </div>
                        </div>
                      </template>
                    </a>
                  </div>
                </template>
                <div class="mobileMenuList__item">
                  <hr class="mobileMenuList__hr">
                </div>
                <div class="mobileMenuList__item text-center">
                  <BaseButton
                    class="mobileMenuList__login isRadius isCol4 mt-3"
                    :class="isLoggedIn ? 'isStyleSecondary' : 'isOutline4'"
                    @click="isLoggedIn ? goToMember() : goToLogin()"
                  >
                    <span v-if="isLoggedIn">會員中心</span>
                    <span v-else>登入｜註冊</span>
                  </BaseButton>
                </div>
              </div>
            </div>
            <div class="mobileMenu__bottom">
              <ul class="py-4" :class="$style.socialList">
                <li
                  class="socialList__item"
                >
                  <a
                    class="socialList__link"
                    href="https://www.instagram.com/jtailspet/"
                    target="_blank"
                  >
                    <i class="fontello fontello-instagram"></i>
                  </a>
                </li>
                <li
                  class="socialList__item"
                >
                  <a
                    class="socialList__link"
                    href="https://www.facebook.com/Jtailspetspa"
                    target="_blank"
                  >
                    <i class="fontello fontello-facebook-light"></i>
                  </a>
                </li>
                <li
                  class="socialList__item"
                >
                  <a
                    class="socialList__link"
                    href="http://line.me/ti/p/@jtails"
                    target="_blank"
                  >
                    <i class="fontello fontello-line"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>
<!-- section style -->
<style lang="scss" module>
.header {
  // position: relative;
  position: fixed;
  top: 0;
  z-index: $z-index-header;
  width: 100vw;
  height: 144px;
  font-family: $font-serif;

  @media (max-width: 1199px) {
    height: 62px;
  }

  :global {
    .header {
      &__logo {
        height: 53px;
        margin-right: 3rem;
        // padding: 0.688rem 0;

        @include max-lg {
          height: 40px;
        }

        @include max-md {
          height: 60px;
        }

        @media (max-width: 1199px) {
          height: 40px;
          margin-right: 0;
        }
      }

      &__icon {
        font-size: 22px;
        color: #3F3A2E;
        cursor: pointer;

        &:hover, &:focus {
          color: $color-primary;
        }
      }

      &__inner {
        // position: fixed;
        // top: 0;
        // width: 100%;
        height: 144px;
        background: #FFF;
        box-shadow: 0px 0px 16px #0000001A;
        opacity: 1;

        @include max-md {
          height: 62px;
          background: #FFF;
          border-bottom: $color-gray-4 1px solid;
          // box-shadow: 0 1px 2px #1C2C5414;
        }

        @media (max-width: 1199px) {
          height: 62px;
          border-bottom: none;
          box-shadow: 0 3px 5px rgb(28 44 84 / 10%);
        }
      }

      &__headerList {
        display: flex;
        align-items: center;
        justify-content: space-between;

        &--mobile {
          display: none;
          align-items: center;
          justify-content: space-between;
          height: 62px;
          padding: 0;

          @media (max-width: 1199px) {
            display: flex;
          }

          .hambuger {
            width: 22.5px;
            font-size: 22px;

            &__close {
              position: relative;
              align-self: center;
              width: 22.5px;
              height: 22px;

              &::before {
                position: absolute;
                top: 50%;
                left: 0;
                width: 100%;
                height: 1px;
                content: '';
                background-color: #3F3A2E;
                transform: rotate(45deg);
              }

              &::after {
                position: absolute;
                top: 50%;
                left: 0;
                width: 100%;
                height: 1px;
                content: '';
                background-color: #3F3A2E;
                transform: rotate(-45deg);
              }

              &:hover {
                &::before, &::after {
                  background-color: $color-primary;
                }
              }
            }
          }
        }

        @media (max-width: 1199px) {
          display: none;
        }
      }

      &__headerLeft {
        display: flex;
        flex-shrink: 0;
        align-items: center;

        @media (max-width: 1199px) {
          width: auto;
          text-align: center;
        }
      }

      &__headerCenter {
        // width: #{ $container + ($container-gap * 2) + 10 };
        flex: 1;
        padding-top: 11px;
        padding-bottom: 0px;

        @media (max-width: 1199px) {
          display: flex;
          align-items: center;
          justify-content: center;
          padding-top: 10px;
          padding-bottom: 10px;
        }
      }

      &__headerRight {
        display: flex;
        align-items: center;
        justify-content: flex-end;

        .header {
          &__icon {
            &:not(:last-child) {
              margin-right: .5rem;
            }
          }
        }
      }

      &__headerLeft, &__headerRight {
        width: calc((100% - #{$container} + (#{$container-gap} * 2)) / 2);

        @media (max-width: #{$container + 450px}) {
          flex-shrink: 0;
          width: 200px;
        }
        // ===
        // fix: 因為開幕茶會 新增 1100px 結束後請刪除
        // ===
        @media screen and (max-width: 1100px) {
          width: 165px;
        }
        
        @include max-lg {
          width: 165px;
          // 因為開幕茶會 更改成 165px 原本是 180px 結束後請更正回來
        }

        @include max-md {
          width: auto;
        }
      }
    }
  }
}

.menuList {
  @include list-unstyled;

  display: flex;
  align-items: center;

  @include max-md {
    display: none;
  }

  :global {
    .menuList {

      &__btn {
        &.isActive {
          color: $color-primary;
          border-color: $color-primary;
        }
      }

      &__icon {
        font-size: 1rem;
        line-height: 0.875rem;

        @include max-md {
          font-size: 1rem;
        }
      }

      &__link {
        @include link-unstyled;

        position: relative;
        display: block;
        // padding: 0 2.5em;
        font-size: 1rem;
        letter-spacing: .25rem;
        color: $color-wp-text;
        cursor: pointer;
        text-align: center;

        @include max-lg {
          padding: 0 1.25rem;
        }

        @include max-md {
          display: inline-block;
          padding: 1rem 0;
          font-size: calc(1rem + 0.5vw);
        }

        @include max-2sm {
          padding: 0.5rem 0;
        }

        &:focus, &:hover {
          font-weight: 600;

          .menuList {
            &__icon {
              font-weight: 400;
            }
          }
        }

        &.isActive {
          color: $color-primary;
        }
      }

      &__item {
        padding: 1.25rem 0;
        flex: 1;
        color: $color-wp-text;

        @include max-md {
          // padding: 0 1rem;
        }

        @include max-md {
          width: 100%;
          // padding: 0 1.875rem;
          text-align: center;
        }

        &:not(:last-child) {
          .menuList {
            &__link {
              border-right: 1px solid #D1D1D1;
            }
          }
        }

        &:last-child {
          .menuList {
            &__link {
              padding-right: 0;
            }
          }
        }

      }
    }
  }
}

.menuRightList {
  @include list-unstyled;

  display: flex;
  align-items: center;

  @include max-md {
    @include var-height(100, - 168px - 60px);

    flex-direction: column;
    align-content: center;
    justify-content: space-between;
    padding: 2.5rem 0;
  }

  @include max-2sm {
    @include var-height(100, - 152px - 60px);

    padding: 1rem 0;
  }

  :global {
    .menuRightList {
      &__link {
        @include link-unstyled;

        position: relative;
        display: block;
        padding: 0 0.875rem;
        font-size: 0.875rem;
        color: #3F3A2E;
        cursor: pointer;

        @include max-md {
          display: inline-block;
          padding: 1rem 0;
          font-size: calc(1rem + 0.5vw);
        }

        @include max-2sm {
          padding: 0.5rem 0;
        }

        &:focus, &:hover, &.isActive {
          color: $color-primary;
        }

        &.isActive {
          @include unstyled;
        }

        &.isMiniCart {
          position: relative;
          .badge {
            position: absolute;
            top: -12px;
            right: 5px;
            min-width: 20px;
            height: 20px;
            font-size: 12px;
            line-height: 20px;
            background-color: $color-secondary;
            border-radius: 20px;
            color: #fff;
            padding: 0 0.25rem;
            letter-spacing: 0;
            text-align: center;
            font-weight: 600;
            font-family: auto;
          }

          /* &:hover {
            .menuRightList__miniCart {
              opacity: 1;
              pointer-events: 1;
            }
          } */
        }
        
        &.isLoggedIn {
          &::after {
            content: '';
            position: absolute;
            right: 0.1em;
            top: -2px;
            width: 4px;
            height: 4px;
            background: #98B8AD;
            border-radius: 100%;
          }
        }
      }

      &__btn {
        &.isActive {
          color: $color-primary;
          border-color: $color-primary;
        }
      }

      &__icon {
        font-size: 1.375rem;
        line-height: 0.875rem;

        @include max-md {
          font-size: 1rem;
        }
      }

      &__item {
        padding: 1.75rem 0;
        position: relative;

        @include max-md {
          // padding: 0 1rem;
        }

        @include max-md {
          width: 100%;
          // padding: 0 1.875rem;
          text-align: center;
        }

        &:last-child {
          .menuRightList {
            &__link {
              padding-right: 0;
            }
          }
        }

        &:first-child {
          .menuRightList {
            &__link {
              padding-left: 0;
            }
          }
        }
      }

      &__search {
        display: flex;
        align-items: center;
      }

      &__miniCart {
        position: absolute;
        bottom: 0;
      }
    }
  }
}

.bottomMenuList {
  margin-bottom: 1.5rem;
  text-align: center;

  :global {
    ul {
      @include list-unstyled;
    }

    .bottomMenuList {
      &__title {
        margin-bottom: .8rem;
        font-size: 0.875rem;
        font-weight: 500;
      }

      &__item {
        @include unstyled;
      }

      &__link {
        @include link-unstyled;

        font-size: 0.75rem;
        line-height: 2;
        color: #3F3A2E;

        &:hover, &:focus {
          color: $color-primary;
        }
      }
    }
  }
}

.bottomMenu {
  padding-top: 2rem;

  @include max-2sm {
    padding-top: 1rem;
  }

  :global {
    .bottomMenu {
      @include unstyled;
    }
  }
}

.socialList {
  @include list-unstyled;

  display: flex;
  align-items: center;
  width: 194px;
  justify-content: space-between;
  padding: 0.5rem 0 1rem;
  margin: 0 auto;
  // background-color: rgba(#EFE5E0, .3);

  :global {
    .socialList {
      &__item {
        font-size: 1.25rem;
        text-decoration: none;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 38px;
        height: 38px;
        background: rgba($color-secondary, 0.15);
        color: $color-secondary;
        border-radius: 100%;
        letter-spacing: 0;

        &:hover {
          background: rgba($color-secondary, 0.3);
        }
      }

      &__link {
        @include link-unstyled;

        color: $color-secondary;
        cursor: pointer;
      }
    }
  }
}

.headerSearch {
  :global {
    .headerSearch {
      &__box {
        display: inline-block;

        @media (max-width: 1199px) {
          height: 60px !important;
          background: white !important;
        }

        .container {
          width: auto;
          padding: 0;

          @include max-xl {
            display: flex;
            width: 100%;
            padding: 0 $container-gap;
          }
        }
      }

      &__inputBox {
        @include max-xl {
          width: 100%;
        }
      }

      &__input {
        padding: 0;
        margin-right: 1rem;
        font-size: 14px;
        letter-spacing: 0.2em;
        border: unset;
        border-radius: 0;
        outline: none;

        @media (max-width: 1199px) {
          height: 60px !important;
        }
      }

      &__close {
        display: none;

        @include max-xl {
          display: block;
        }
      }

      @media (max-width: 1200px) {
        /* top: 27.5%;
        right: 9.9rem;
        font-size: 26px; */

        /* @include max-xl {
          top: 22%;
          right: 7.4rem;
          font-size: 22px;
        } */
        &__box {
          position: fixed;
          top: 0;
          left: 0;
          z-index: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          height: 80px;
          background: #faf7f6;

          /* @include max-xl {
            height: 62px;
          } */
          .container {
            /* @include max-xl {
              padding: 0 $container-gap;
            } */
          }
        }
        &__inputBox {
          position: relative;
          padding-left: 2.5rem;

          &::before {
            position: absolute;
            top: 50%;
            left: 0;
            margin-top: -16px;
            font-family: $font-fontello;
            font-size: 22px;
            content: '\E81D';
          }
        }
        &__input {
          width: 100%;
          height: 85px;
          font-size: 16px;
          background: transparent;
          border: unset;
        }
        &__close {
          position: absolute;
          top: 50%;
          right: 0;
          width: 24px;
          height: 24px;
          margin-top: -12px;

          &::after {
            position: absolute;
            top: 50%;
            left: 0;
            width: 100%;
            height: 1px;
            content: '';
            background-color: rgba(87, 92, 92);
            transform: rotate(-45deg);
          }

          &::before {
            position: absolute;
            top: 50%;
            left: 0;
            width: 100%;
            height: 1px;
            content: '';
            background-color: rgba(87, 92, 92);
            transform: rotate(45deg);
          }

          /* @include max-xl {
            display: block;
          } */
        }
      }
    }
  }
}


.mobileMenu {
  position: fixed;
  top: 60px;
  right: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: calc((var(--vh, 1vh) * 100) - 60px);
  pointer-events: none;
  // background-color: lighten($color-secondary, 20%);
  background-color: white;
  box-shadow: inset 0 3px 5px rgba(28, 44, 84, 10%);
  opacity: 0;
  transition: opacity .3s, transform .3s;
  transform: translateY(-10px);
  overflow: auto;

  &.isMenuOpen {
    pointer-events: auto;
    opacity: 1;
    transform: translateY(0);
  }

  :global {
    .mobileMenu {
      @include unstyled;
    }
  }
}

.mobileMenuList {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1rem 0;
  // background-color: rgba(#EFE5E0, 0.3);
  overflow-y: auto;

  @media screen and (max-width: 1199px) {
    padding: 2rem 0;
  }

  :global {
    .mobileMenuList {
      &__item {
        align-self: stretch;
        padding: 20px;
        cursor: pointer;

        @media screen and (max-width: 1199px) {
          padding: 1.25rem 1.5rem;          
        }
      }

      &__link {
        display: block;
        font-size: 14px;
        color: $color-wp-text;
        text-align: center;

        &.isActive {
          // color: $color-primary;
          .mobileMenuList__sublist {
            max-height: 300px;
            margin-bottom: -30px;
          }

          .dropdown-button {
            transform: rotate(180deg);
          }
        }

        i {
          font-size: 18px;
          transition: .2s transform;
        }

        @media screen and (max-width: 1199px) {
          text-align: left;
          font-size: 1rem;
          letter-spacing: 0.25em;
        }
      }

      &__hr {
        // width: 270px;
        margin: 1vh 0;
        background: $color-line;
        opacity: 0.5;
      }

      &__login {
        padding: 1.2rem 1.5rem;
        font-size: 1rem;
        font-family: sans-serif;
        font-weight: 600;
      }

      &__sublist {
        max-height: 0;
        overflow: hidden;
        transition: max-height 0.3s ease-out;

        .mobileMenuList__item {
          padding: 1rem 1.5rem;
        }
      }
    }
  }
}

.mobileMenuListB {
  padding-bottom: 2rem;
  font-family: $font-sans;
  text-align: center;

  :global {
    .mobileMenuListB {
      &__title {
        margin-bottom: 0.5rem;
      }

      &__item {
        @include unstyled;
      }

      &__link {
        display: block;
        font-size: 0.75rem;
        color: #3F3A2E;
        text-align: center;

        &.isActive {
          color: $color-primary;
        }

        i {
          font-size: 18px;
        }
      }
    }
  }
}
</style>
<style lang="scss">
/* #scrollBar {
  padding-top: 80px;

  @include max-lg {
    padding-top: 67px;
  }

  @media (max-width: 1199px) {
    padding-top: 60px;
  }
} */
</style>

